import React, { Component } from "react"
import { withStyles } from '@material-ui/core/styles';
import { TextField, Select, MenuItem, InputBase, InputAdornment, IconButton, FormControl, FormHelperText } from "@material-ui/core"
import Save from "../../../Assets/img/svg/save.svg"
import Saveblue from "../../../Assets/img/svg/saveblue.svg"
import Cancel from "../../../Assets/img/svg/cancel.svg"
import Cancelblue from "../../../Assets/img/svg/cancelblue.svg"
import image from "../../../Assets/img/svg/Image.svg"
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../Assets/jss/customStyle";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Delete from "../../../Assets/img/svg/delete.svg"
import del from "../../../Assets/img/svg/Del.svg"
import $ from "jquery"
import moment from "moment"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../helpers/endpointService"
import deactive from '../../../Assets/img/svg/deactive.svg';
import InnerImageZoom from "react-inner-image-zoom";
import { getSettingsFormat } from "../../../actions/SettingsAction"
import { VesselStatus, inspectionSystem } from "../../Constants";
import { addshipbasicinfo, filedeleteshiplogo, addshiplogoinfo, filedeleteship, putshipbasicinfo } from "../../../actions/AddNewShipAction";
import { getInspectionTypeList, getStatusTypeList, getShipTypeList, } from "../../../actions/Lookup"

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

class NewEnquiry extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            menu: true,
            cancel: false,
            isError1: false,
            isError2: false,
            isError3: false,
            isError4: false,
            isError5: false,
            DateOfInspection: "",
            addData: {
                "Id": 0,
                "VesselName": "",
                "Imonumber": "",
                "TypeOfVessel": "",
                "InspectionRequested": "",
                "DateOfInspection": "",
                "Location": "",
                "EmailOfRequestor": "",
                "PhoneNumberOfRequestor": "",
                "Comments": "",
                "CreatedBy": "",
                "CreatedDate": "",
                "ModifiedBy": "",
                "ModifiedDate": ""
            },
        }
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(getInspectionTypeList(VesselStatus.InspectionType));
        dispatch(getShipTypeList(VesselStatus.ShipType));
        this.state.addData.CreatedBy = JSON.parse(localStorage.getItem("currentUser")).email;
        this.state.addData.ModifiedBy = JSON.parse(localStorage.getItem("currentUser")).email;
        this.state.addData.CreatedDate = moment(new Date()).format("yyyy-MM-DD");
        this.state.addData.ModifiedDate = moment(new Date()).format("yyyy-MM-DD");
        this.setState({})
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.interval = setInterval(() => {
            this.resize1();
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#NewEnquiry1 .MuiListItemText-primary").removeClass("fw-bolder")
        $("#NewEnquiry1 .MuiListItemText-primary").removeClass("spanTopBar")
        $("#NewEnquiry").addClass("d-none")
        $("#NewEnquiry").removeClass("d-block")
    }

    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            if (this.state.isEdit == true) {
                this.props.navigate("/sidebareditship");
            }
            else {
                this.props.navigate("/sidebaraddship");
            }
        }

    };

    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        if (this.state.isEdit == true) {
            this.props.navigate("/sidebareditship");
        }
        else {
            this.props.navigate("/sidebaraddship");
        }
    }

    resize1 = () => {
        $("#NewEnquiry1 .MuiListItemText-primary").addClass("fw-bolder")
        $("#NewEnquiry1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#NewEnquiry").removeClass("d-none")
        $("#NewEnquiry").addClass("d-block")
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/shiplist`)
        }
    }

    handleInputChange = (e, node) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true;
        console.log(e.target.value, node)
        if (node === "Comments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData.Comments = e.target.value;
            }
        }
        if (node === "DateOfInspection") {
            this.state.DateOfInspection = e.target.value;
            this.setState({})
            var xdate = this.state.DateOfInspection.split('-');
            this.state.addData.DateOfInspection = xdate[2] + "/" + xdate[1] + "/" + xdate[0];
        }
        else {
            this.state.addData[node] = e.target.value;
        }
        this.setState({});

    };

    Save = () => {
        const { VesselName, DateOfInspection, Location, EmailOfRequestor, PhoneNumberOfRequestor } = this.state.addData
        if (VesselName.trim() === "") {
            this.state.isError1 = true;
            this.state.addData.VesselName = this.state.addData.VesselName.trim();
            this.setState({})
        }
        else {
            this.state.isError1 = false;
            this.state.addData.VesselName = this.state.addData.VesselName.trim();
            this.setState({})
        }
        if (DateOfInspection === "") {
            this.state.isError2 = true;
            this.state.addData.DateOfInspection = this.state.addData.DateOfInspection;
            this.setState({})
        }
        else {
            this.state.isError2 = false;
            this.state.addData.DateOfInspection = this.state.addData.DateOfInspection;
            this.setState({})
        }
        if (Location === "") {
            this.state.isError3 = true;
            this.state.addData.Location = this.state.addData.Location;
            this.setState({})
        }
        else {
            this.state.isError3 = false;
            this.state.addData.Location = this.state.addData.Location;
            this.setState({})
        }
        let email = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (email.test(EmailOfRequestor)) {
            this.state.isError4 = false;
            this.state.addData.EmailOfRequestor = this.state.addData.EmailOfRequestor;
            this.setState({})
        }
        else {
            this.state.isError4 = true;
            this.state.addData.EmailOfRequestor = this.state.addData.EmailOfRequestor;
            this.setState({})
        }
        if (PhoneNumberOfRequestor === "") {
            this.state.isError5 = true;
            this.state.addData.PhoneNumberOfRequestor = this.state.addData.PhoneNumberOfRequestor;
            this.setState({})
        }
        else {
            this.state.isError5 = false;
            this.state.addData.PhoneNumberOfRequestor = this.state.addData.PhoneNumberOfRequestor;
            this.setState({})
        }
        if (this.state.addData.VesselName !== "" && this.state.addData.DateOfInspection !== "" && this.state.addData.Location !== "" && this.state.addData.EmailOfRequestor !== "" && this.state.addData.PhoneNumberOfRequestor !== "") {
            this.addenquiryinfo(this.state.addData)
        }
    };

    addenquiryinfo = (data) => {
        let apiUrl = API.POST_Enquiry;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    console.log(response.data)
                    this.setState({
                        cancel: false,
                        DateOfInspection: "",
                        addData: {
                            "Id": 0,
                            "VesselName": "",
                            "Imonumber": "",
                            "TypeOfVessel": "",
                            "InspectionRequested": "",
                            "DateOfInspection": "",
                            "Location": "",
                            "EmailOfRequestor": "",
                            "PhoneNumberOfRequestor": "",
                            "Comments": "",
                            "CreatedBy": JSON.parse(localStorage.getItem("currentUser")).email,
                            "CreatedDate": moment(new Date()).format("yyyy-MM-DD"),
                            "ModifiedBy": JSON.parse(localStorage.getItem("currentUser")).email,
                            "ModifiedDate": moment(new Date()).format("yyyy-MM-DD")
                        }
                    })
                    window.$("#savepopup").modal("show");
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    render() {
        const { addData, DateOfInspection, isError1, isError2, isError3, isError4, isError5 } = this.state;
        let { classes, menuToggle, inspectionType, shipType } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4 mob-topfixed ">
                                <div className="col-7 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Basic" + "1"} className='textNaviIcon' primary={"New Enquiry"} />
                                            <NavigateNextIcon id="Basic" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5 ">
                                    <h4 className="pt-2">New Enquiry</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide mt-130" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? localStorage.getItem("UserRoles").toLowerCase() == "client" ? "calc(100% - 300px)" : "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -75 }}>
                    {this.state.isMobile ?
                        <table className="dataTable border-top" width="100%">
                            <tbody>
                                <tr>
                                    <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                    <td className="border-right text-center" >
                                        <button className={`${classes.button}`} /*disabled={isAccessControl ? true : false}*/ onClick={() => this.Save()}><img src={localStorage.getItem("UserRoles").toLowerCase() === "client" ? Saveblue : Save} style={{ marginTop: '-4px', /*opacity: isAccessControl ? "0.5" : ""*/ }}></img>&nbsp;Submit</button>
                                    </td>
                                    <td className=" text-center">
                                        <button className={`${classes.button} `} /*disabled={isAccessControl ? true : false}*/ onClick={this.AddCancel1}><img src={localStorage.getItem("UserRoles").toLowerCase() === "client" ? Cancelblue : Cancel} style={{ marginTop: '-4px', /*opacity: isAccessControl ? "0.5" : ""*/ }}></img>&nbsp;Cancel</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        :
                        <>
                            <table className="dataTable" width="100%">
                                <tbody>
                                    <tr>
                                        <td width="5%" className="border-right text-center">
                                            <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                        <td className="95%">
                                            <button className={classes.button} /*disabled={isAccessControl ? true : false}*/ onClick={() => this.Save()}><img src={localStorage.getItem("UserRoles").toLowerCase() === "client" ? Saveblue : Save} style={{ marginTop: '-4px', /*opacity: isAccessControl ? "0.5" : ""*/ }}></img>&nbsp;Submit</button>
                                            <button className={`${classes.button} pl-3`} /*disabled={isAccessControl ? true : false}*/ onClick={this.AddCancel1}><img src={localStorage.getItem("UserRoles").toLowerCase() === "client" ? Cancelblue : Cancel} style={{ marginTop: '-4px', /*opacity: isAccessControl ? "0.5" : ""*/ }}></img>&nbsp;Cancel</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    }
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">{"New Enquiry"}</h6>}
                        <div className={this.state.isMobile ? "row mx-0 mt-2" : "row mx-1 px-3 mt-2"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "float-end d-flex text-right m-0"}>Vessel Name&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError1 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={addData?.VesselName && addData?.VesselName}
                                            onChange={(e) => { this.handleInputChange(e, "VesselName") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={addData?.VesselName && addData?.VesselName}
                                            onChange={(e) => { this.handleInputChange(e, "VesselName") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "d-flex m-0 text-right float-end"}>IMO Number&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={addData?.Imonumber && addData?.Imonumber}
                                        onChange={(e) => { this.handleInputChange(e, "Imonumber") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end "}>Type of Vessel&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <>
                                        <select
                                            fullWidth
                                            value={this.state.addData?.TypeOfVessel && this.state.addData?.TypeOfVessel}
                                            style={{ height: "40px" }}
                                            className="form-control border-radius shiptype-select"
                                            onChange={(e) => { this.handleInputChange(e, "TypeOfVessel") }}
                                        >
                                            <option value={0}>Select Type of Vessel</option>
                                            {shipType &&
                                                shipType.map((type, index) => (
                                                    <option value={type.Name}>{type.Name}</option>
                                                ))}
                                        </select>
                                    </>
                                </div>
                            </div>

                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end "}>Inspection Requested&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <>
                                        <select
                                            fullWidth
                                            value={this.state.addData?.InspectionRequested}
                                            style={{ height: "40px" }}
                                            className="form-control border-radius"
                                            onChange={(e) => { this.handleInputChange(e, "InspectionRequested") }}
                                        >
                                            <option value={0}>Select Inspection Requested</option>
                                            {inspectionType && inspectionType?.map((item, index) => (
                                                <option value={item.Name}>{item.Name}</option>
                                            ))}
                                        </select>
                                    </>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "float-end d-flex text-right m-0"}>Date of Inspection&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <>
                                        {isError2 ?
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                error
                                                id="type-date"
                                                type="date"
                                                fullWidth
                                                value={(DateOfInspection != "" && moment(DateOfInspection).format("yyyy-MM-DD") != "Invalid Date") ? moment(DateOfInspection).format("yyyy-MM-DD") : ""}
                                                placeholder={(DateOfInspection != "" && moment(DateOfInspection).format("yyyy-MM-DD") != "Invalid Date") ? moment(DateOfInspection).format("DD/MM/YYYY") : ""}
                                                onChange={(e) => { this.handleInputChange(e, "DateOfInspection") }}
                                                InputProps={{
                                                    className: `border-radius ${classes.inputfieldAlign}`,
                                                    style: { fontSize: 12 }
                                                }}
                                                classes={{ root: classes.helperText }}
                                            /> :
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                type="date"
                                                id="type-date"
                                                fullWidth
                                                value={(DateOfInspection != "" && moment(DateOfInspection).format("yyyy-MM-DD") != "Invalid Date") ? moment(DateOfInspection).format("yyyy-MM-DD") : ""}
                                                placeholder={(DateOfInspection != "" && moment(DateOfInspection).format("yyyy-MM-DD") != "Invalid Date") ? moment(DateOfInspection).format("DD/MM/YYYY") : ""}
                                                onChange={(e) => { this.handleInputChange(e, "DateOfInspection") }}
                                                InputProps={{
                                                    className: `border-radius ${classes.inputfieldAlign}`,
                                                    style: { fontSize: 12 }
                                                }}
                                            />}
                                    </>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "float-end d-flex text-right m-0"}>Location&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <>{isError3 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={addData?.Location && addData?.Location}
                                            onChange={(e) => { this.handleInputChange(e, "Location") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={addData?.Location && addData?.Location}
                                            onChange={(e) => { this.handleInputChange(e, "Location") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                        />}
                                    </>
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "float-end d-flex text-right m-0"}>Contact Email of Requestor&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <>
                                        {isError4 ?
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error
                                                value={addData?.EmailOfRequestor && addData?.EmailOfRequestor}
                                                onChange={(e) => { this.handleInputChange(e, "EmailOfRequestor") }}
                                                InputProps={{
                                                    className: `border-radius ${classes.inputfieldAlign}`,
                                                    style: { fontSize: 12 }
                                                }}
                                                classes={{ root: classes.helperText }}
                                            /> :
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                value={addData?.EmailOfRequestor && addData?.EmailOfRequestor}
                                                onChange={(e) => { this.handleInputChange(e, "EmailOfRequestor") }}
                                                InputProps={{
                                                    className: `border-radius ${classes.inputfieldAlign}`,
                                                    style: { fontSize: 12 }
                                                }}
                                            />}
                                    </>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "float-end d-flex text-right m-0"}>Phone Number of Requestor&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <>
                                        {isError5 ?
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error
                                                value={addData?.PhoneNumberOfRequestor}
                                                onChange={(e) => { this.handleInputChange(e, "PhoneNumberOfRequestor") }}
                                                InputProps={{
                                                    className: `border-radius ${classes.inputfieldAlign}`,
                                                    style: { fontSize: 12 }
                                                }}
                                                classes={{ root: classes.helperText }}
                                            /> :
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                value={addData?.PhoneNumberOfRequestor}
                                                onChange={(e) => { this.handleInputChange(e, "PhoneNumberOfRequestor") }}
                                                InputProps={{
                                                    className: `border-radius ${classes.inputfieldAlign}`,
                                                    style: { fontSize: 12 }
                                                }}
                                            />}
                                    </>
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right mt-n4"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0 " : "form-group m-0 float-end text-right"}>Comments&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2  pb-1 " : "col-md-10 pt-4  pb-2 "}`}>
                                    <TextField
                                        multiline
                                        rows={8}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData?.Comments}
                                        onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.Comments?.length}/1000 Characters left</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopuplogo" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#499AC8", border: "none" }} onClick={() => this.DeleteItemlogo()}><span className="" >Delete</span></button>
                                <button type="button" onClick={() => { window.$("#deletepopuplogo").modal("hide") }} id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="savepopup" tabindex="-1" role="dialog" aria-labelledby="savepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <div className="text-center p-4">
                                    <h5 class="fw-bold">Submitted Successfully</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#savepopup").modal("hide")} style={{ backgroundColor: "#499AC8", border: "none" }}><span className="" >Ok</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Changes are not saved yet. The data will be lost. Do you really want to cancel?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#499AC8", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        alertCancel: state.commonReducer.alertCancel || [],
        inspectionType: state.lookupReducer.inspectionType || [],
        shipType: state.lookupReducer.shipType || [],
    };
}

NewEnquiry.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NewEnquiry))
);